export default __webpack_public_path__ + "static/media/crypties.6e2f7b67.png";